import { useEffect, useRef, useState } from "react";
import { FaEnvelopeOpen, FaMapMarkerAlt, FaPhoneAlt } from "react-icons/fa";
import ScrollToTop from "../components/ScrollToTop";
import toast, { Toaster } from "react-hot-toast";
import HelmetComponent from "../components/Helmet";

const ContactUs = () => {
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phoneNumber: '',
        message: ''
    });
    const contactSection = useRef(null);
    // Handle input changes
    const handleInputChange = (e) => {
        const { id, value } = e.target;
        setFormData({
            ...formData,
            [id]: value,
        });
    };
    useEffect(() => {
        if (contactSection.current) {
            contactSection.current.scrollIntoView({ behavior: "auto" });
        }
    }, []);
    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();

        // Prevent multiple clicks
        if (loading) return;

        // Validation
        if (!/\S+@\S+\.\S+/.test(formData.email)) {
            toast.error("Invalid email");
            return;
        }

        if (formData.phoneNumber.length < 10) {
            toast.error("Invalid phone number");
            return;
        }

        if (!formData.name || !formData.email || !formData.phoneNumber || !formData.message) {
            toast.error("Please fill all required fields!");
            return;
        }


        try {
            setLoading(true);

            const request = fetch(`${process.env.REACT_APP_BACKEND_SITE}/api/contactus`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            const response = await toast.promise(
                request,
                {
                    loading: 'Sending...',
                    success: 'Thank You For Contacting Us , We Will Contact You Soon.',
                    error: 'Sending failed. Please try again.',
                }
            );

            const data = await response.json();

            if (response.ok) {
                // Reset form
                setFormData({
                    name: '',
                    email: '',
                    phoneNumber: '',
                    message: ''
                });
            } else {
                toast.error(data.error || "Something went wrong");
            }

        } catch (error) {
            toast.error(error.message || "Network error");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>

            <div className="max-lg:px-5 lg:px-5 py-4">
                <HelmetComponent
                    title="Contact Us - Shri Radhe Holidays | Travel Assistance & Booking"
                    description="Contact Shri Radhe Holidays for domestic and international tour packages, flight bookings, hotels, visa assistance and customized travel planning."
                    url="https://www.shriradheholidays.com/contact"
                />

                <div className="scroll-mt-[90px]" ref={contactSection}>
                    <div className={`my-6 text-start border-l-8 rounded-r-full bg-[#0B1C3D]  border-[#D4AF37] wow fadeInUp max-sm:w-[70%] xl:w-[50%] transform -skew-x-12`} data-wow-delay="0.1s"
                        style={{ boxShadow: ' 0px 0px 20px 5px  rgb(0 0 0 / 32%)' }}
                    >
                        {/* Heading */}
                        <h1 className=" playfair-display font-extrabold py-[6px] px-2 max-lg:text-xl text-2xl text-white">
                            Contact Us
                        </h1>
                        {/* <h6 className="mb-5">Contact For Any Query</h6> */}
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 ">
                        <div className={`h-full wow fadeInUp `} data-wow-delay="0.01s">
                            <h5 className="hanuman-regular">Get In Touch</h5>
                            <p className="mb-4 poppins">
                                Have questions or need assistance with your travel plans?
                                Our team is here to help you with flights, hotels, holiday packages, and more.
                                Contact us today for a seamless and stress-free travel experience.
                            </p>

                            <div className="flex items-center mb-4">
                                <div className="flex items-center justify-center flex-shrink-0 bg-[#D4AF37]" style={{ width: "50px", height: "50px" }}>
                                    <FaMapMarkerAlt className="text-white" />
                                </div>
                                <div className="ms-3">
                                    <h5 className="playfair-display" style={{ fontWeight: "bold", color: "#D4AF37" }}>Office</h5>
                                    <p className="mb-0 text-black poppins">WB-82, Shakarpur, Laxmi Nagar , New
                                        Delhi</p>
                                </div>
                            </div>
                            <div className="flex items-center mb-4">
                                <div className="flex items-center justify-center flex-shrink-0 bg-[#D4AF37]" style={{ width: "50px", height: "50px" }}>
                                    <FaPhoneAlt className="text-white" />
                                </div>
                                <div className="ms-3">
                                    <h5 className="playfair-display" style={{ fontWeight: "bold", color: "#D4AF37" }}>Mobile</h5>
                                    <a href="tel:9560070953" className="flex items-center text-black no-underline cursor-pointer poppins">+91 9560070953</a>
                                </div>
                            </div>
                            <div className="flex items-center">
                                <div className="flex items-center justify-center flex-shrink-0 bg-[#D4AF37]" style={{ width: "50px", height: "50px" }}>
                                    <FaEnvelopeOpen className="text-white" />
                                </div>
                                <div className="ms-3">
                                    <h5 className="playfair-display" style={{ fontWeight: "bold", color: "#D4AF37" }}>Email</h5>
                                    <a className="flex items-center  text-black no-underline cursor-pointer poppins" href="mailto:shriradheholidayss@gmail.com?subject=Inquiry&body=Hello, I would like to know more about your services." >shriradheholidayss@gmail.com</a>
                                </div>
                            </div>
                        </div>
                        <div className={`h-full wow fadeInUp `} data-wow-delay="0.01s">
                            <iframe title="map" className="w-full h-full min-h-[300px]"
                                src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d791.4749994755914!2d77.28121418394247!3d28.626379854657824!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e1!3m2!1sen!2sus!4v1737638356036!5m2!1sen!2sus"
                                frameBorder="0" style={{ minHeight: "300px", border: "0" }} allowFullScreen="" aria-hidden="false"
                                tabIndex="0"></iframe>
                        </div>
                        <div className={`h-full md:col-span-2 lg:col-span-1 wow fadeInUp `} data-wow-delay="0.01s">
                            <form onSubmit={handleSubmit}>
                                <div className="row g-3">
                                    <div className="col-md-6">
                                        <div className="form-floating">
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="name"
                                                placeholder="Your Name"
                                                value={formData.name}
                                                onChange={handleInputChange}
                                                required
                                            />
                                            <label htmlFor="name">Your Name</label>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-floating">
                                            <input
                                                type="email"
                                                className="form-control"
                                                id="email"
                                                placeholder="Your Email"
                                                value={formData.email}
                                                onChange={handleInputChange}
                                                required
                                            />
                                            <label htmlFor="email">Your Email</label>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-floating">
                                            <input
                                                type="number"
                                                className="form-control"
                                                id="phoneNumber"
                                                placeholder="Phone Number"
                                                value={formData.phoneNumber}
                                                onChange={handleInputChange}
                                                required
                                            />
                                            <label htmlFor="phoneNumber">Phone Number</label>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-floating">
                                            <textarea
                                                className="form-control"
                                                id="message"
                                                placeholder="Leave a message here"
                                                value={formData.message}
                                                onChange={handleInputChange}
                                                style={{ height: '100px' }}
                                                required
                                            ></textarea>
                                            <label htmlFor="message">Message</label>
                                        </div>
                                    </div>
                                    <div className="col-12 w-100 flex justify-center items-center">
                                        <button className="fancy-button w-[50%]  flex justify-center items-center" >
                                            <div className="svg-wrapper gap-2">
                                                <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" width="20px">
                                                    <path fill="currentColor" d="M476 3.2L12.5 270.6c-18.1 10.4-15.8 35.6 2.2 43.2L121 358.4l287.3-253.2c5.5-4.9 13.3 2.6 8.6 8.3L176 407v80.5c0 23.6 28.5 32.9 42.5 15.8L282 426l124.6 52.2c14.2 6 30.4-2.9 33-18.2l72-432C515 7.8 493.3-6.8 476 3.2z" />
                                                </svg>
                                                <span className="">Send</span>
                                            </div>
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <Toaster
                position="top-center"
                reverseOrder={false}
            />
            {/* Footer Section */}
            {/* <div className="text-center mt-8">
                <p className="dancing-script-font text-4xl md:text-6xl text-[#D4AF37] ">
                    Shri Radhe Holidays
                </p>
                <p className="text-sm md:text-lg mt-0 hanuman-regular">
                    Creating Unforgettable Memories
                </p>
            </div> */}

            {/* <!-- Back to Top --> */}
            <ScrollToTop />
        </>
    )
}
export default ContactUs;